module.exports = __webpack_public_path__ + "img/invoice-de-male-wm-banner-sn.d7218736.png";